<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  methods:{
  },
  created(){
    // 添加事件监听器
  document.addEventListener('dragstart', (e) => {
    if (e.target.tagName === 'IMG') {
      // 阻止默认的拖动行为
      e.preventDefault();
    }
  });
  }
}
</script>

<style lang="less">
html,body,h3,p{
  margin: 0px;
  padding: 0px;
}
</style>
